import { render, staticRenderFns } from "./EditUserPopup.vue?vue&type=template&id=4c976b4b&scoped=true"
import script from "./EditUserPopup.vue?vue&type=script&lang=js"
export * from "./EditUserPopup.vue?vue&type=script&lang=js"
import style0 from "./EditUserPopup.vue?vue&type=style&index=0&id=4c976b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c976b4b",
  null
  
)

export default component.exports